/* ====================================================================
   Lunai product enhancements
   1) Colour swatches — maps Slovenian colour names to real colours and
      renders the "Barva" variant option (and catalog card dots) as
      colour swatches. No Shopify swatch setup required.
   2) Sticky mobile add-to-cart bar that mirrors the product form.
   ==================================================================== */
(function () {
  var LS = window.lunaiStrings || {};
  var MAP = {
    'roza': '#E3A9B8', 'mehko roza': '#F1D2DB', 'pudrasta': '#E6C3CB',
    'ekru': '#ECE4D2', 'krem': '#F0E7D2', 'bela': '#FBFBF8', 'jajčno bela': '#F2EBDC',
    'siva': '#9BA0A0', 'pepelnata': '#BCC0BA', 'megla': '#CDD2CD',
    'bež': '#D8C29C', 'peščena': '#DCC59A', 'taupe': '#8E7F6E',
    'rjava': '#6F4E37', 'čokoladna': '#4A3326', 'mokka': '#7B5C45',
    'marelična': '#E7A57B', 'oranžna': '#E08A4E', 'črna': '#2B2B29',
    'zlata': '#C6A24C', 'šampanjec': '#E5D7B2', 'vijolična': '#8E7CA8',
    'zelena': '#7E8B5C', 'gozdna': '#3F5340', 'modra': '#5B7C99',
    'svetlo modra': '#AAC5D7', 'mornarsko modra': '#2C3E50', 'azur': '#6FA8C7',
    'sivka': '#B8A8CA', 'ocean': '#4F7E8C', 'calm': '#BAC7C3',
    'piškotna': '#D9B98A', 'kovinska': '#B6B6B6', 'rumena': '#E5C65A',
    /* catalog v3 vocabulary — Slovenian basics */
    'kremna': '#F0E7D2', 'naravna': '#DDD0B8', 'nežno roza': '#F2D4CE',
    'golobje siva': '#A8A6A4', 'jeklena': '#8E959C', 'rjavo bež': '#B99B7C',
    /* Carinio / Gauchito / Brott fantasy names (curated hexes — adjust to
       supplier legend when it arrives) */
    'blush': '#EFC0B2', 'fog': '#C9C5BD', 'cloud': '#EDEBE6', 'dove': '#C8C2BA',
    'latte': '#C7A583', 'biscuit': '#E3C9A3', 'lavende': '#B8A8CA',
    'aztec desert': '#C98F5F', 'four leaf clover': '#7FA070', 'royal palace': '#39537B',
    'escranc': '#D96F4E', 'calafell': '#E4C05C', 'llavaneres': '#7E8B5C',
    'pedrosa': '#B5544A', 'sadurni': '#5B7C99', 'garbet': '#3F5340',
    'taupe zlata': '#B3A075', 'bamboo': '#CBB98A',
    /* Catalogue colour values, hexes taken verbatim from the cleaned
       shopify.color-pattern metaobject library (Phase 2). Patterned values
       (karo, pepita, zebra, črte, pike) carry the library's representative
       colour so the facet dot and the PDP swatch always agree. */
    'čokoladno rjava': '#6B4833', 'modro vijolična': '#7589F0',
    'modro zelena': '#386D80', 'mornarsko modre črte': '#60A1CD',
    'olivno zelena': '#738B1D', 'pepita črna': '#312B2B',
    'pisana limeta': '#E2F4C3', 'rdeče roza': '#EB1455',
    'rdeči karo': '#F61F1F', 'rjava s pikami': '#6A4020',
    'roza karo': '#F2A6D7', 'sivo modra': '#577894',
    'sivo vijolična': '#AB95AC', 'sivo zelena': '#8EC7AA',
    'srebrna': '#B4B8BB', 'svetlo rjavi karo': '#DFB477',
    'svetlo zlata': '#F5D584', 'temno rdeča': '#AD241A',
    'temno roza': '#9B4B58', 'umazano bela': '#F3EFE2',
    'umazano roza': '#EAA4A4', 'zeleni karo': '#9FC6A7',
    'črno / bež zebra': '#DBD0A4', 'rjavo / zlata zebra': '#9A5630',
    'pepita sivo / bež': '#D4CFB5',
    /* R2.1: the 7 curated Lunai filter colours (prototype palette) */
    'pudrasto roza': '#CE9384', 'žajbelj': '#9CA886', 'terakota': '#B5704F',
    'oliva': '#6B7458', 'antracit': '#403A33', 'med': '#C9A24A',
    /* English colour names (current catalog import is English-sourced) */
    'pink': '#E3A9B8', 'light pink': '#F1D2DB', 'rose': '#E6C3CB', 'rosa': '#E6C3CB',
    'white': '#FBFBF8', 'cream': '#F0E7D2', 'ecru': '#ECE4D2', 'ivory': '#F2EBDC',
    'grey': '#9BA0A0', 'gray': '#9BA0A0', 'light grey': '#CDD2CD', 'light gray': '#CDD2CD',
    'beige': '#D8C29C', 'sand': '#DCC59A', 'camel': '#C19A6B',
    'brown': '#6F4E37', 'chocolate': '#4A3326', 'mocha': '#7B5C45',
    'apricot': '#E7A57B', 'orange': '#E08A4E', 'black': '#2B2B29',
    'gold': '#C6A24C', 'gold with black': '#C6A24C', 'champagne': '#E5D7B2',
    'purple': '#8E7CA8', 'lavender': '#B8A8CA', 'lilac': '#CDB9D9',
    'green': '#7E8B5C', 'olive': '#6B7458', 'khaki': '#8A8B5C', 'forest': '#3F5340',
    'blue': '#5B7C99', 'light blue': '#AAC5D7', 'navy': '#2C3E50', 'navy blue': '#2C3E50',
    'red': '#B04A42', 'burgundy': '#7A3B3F', 'yellow': '#E5C65A', 'mustard': '#C9A544',
    'silver': '#B6B6B6', 'turquoise': '#5FA8A0', 'mint': '#B8D4C4'
  };
  var PATTERN = 'conic-gradient(from 210deg, #E3A9B8, #E5C65A, #7E8B5C, #6FA8C7, #B8A8CA, #E3A9B8)';
  function isPattern(n) { return /vzorec|pattern|mix|mešano|dekor|floral|cvetli|večbarvno/.test(n); }
  function bgFor(name) {
    if (!name) return null;
    var n = name.trim().toLowerCase();
    if (isPattern(n)) return PATTERN;
    if (MAP[n]) return MAP[n];
    /* multi-part values: "Rjava / marelicna", "Siva in roza",
       "Roza - rdeca - oranzna", "Orange, Green, Blue" */
    var parts = null;
    if (n.indexOf('/') > -1) parts = n.split('/');
    else if (n.indexOf(' - ') > -1) parts = n.split(' - ');
    else if (n.indexOf(',') > -1) parts = n.split(',');
    else if (n.indexOf(' in ') > -1) parts = n.split(' in ');
    if (parts && parts.length > 1) {
      var cols = parts.map(function (s) { return MAP[s.trim()] || '#C9BFA9'; });
      if (cols.length >= 3) return 'conic-gradient(from 210deg, ' + cols.join(', ') + ', ' + cols[0] + ')';
      return 'linear-gradient(135deg, ' + cols[0] + ' 0 50%, ' + cols[1] + ' 50% 100%)';
    }
    return null;
  }
  // shared with lunai-facets.js (BARVA facet swatch dots)
  window.lunaiSwatchBg = bgFor;
  function decoratePicker(root) {
    (root || document).querySelectorAll('variant-selects fieldset, .product-form__input--pill').forEach(function (fs) {
      if (fs.__sw) return;
      /* Phase 4 (§26): Shopify's own swatch data wins. Where the Barva option
         is linked to the `shopify.color-pattern` metaobject, Dawn already
         renders real swatches with a complete state model (checked / hover /
         focus-visible / unavailable-with-cross). Painting the hardcoded
         name→hex map over them produced two swatch systems in one row —
         different sizes, different selected rings, and two of four colours
         simply wrong. The map below stays as the FALLBACK for option values
         Shopify has no swatch for. */
      if (fs.classList.contains('product-form__input--swatch')) return;
      var first = fs.querySelector('input[type="radio"]');
      var legend = fs.querySelector('legend');
      var isColour = (first && /barv|colou?r/i.test(first.getAttribute('data-option-name') || '')) ||
        (legend && /barv|colou?r/i.test(legend.textContent));
      if (!isColour) return;
      var any = false;
      fs.querySelectorAll('input[type="radio"]').forEach(function (inp) {
        var label = fs.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(inp.id) : inp.id) + '"]');
        if (!label) return;
        var bg = bgFor(inp.value);
        if (!bg) return;
        label.style.setProperty('--sw', bg);
        label.classList.add('lunai-swatch');
        label.setAttribute('title', inp.value);
        any = true;
      });
      if (any) { fs.classList.add('lunai-swatch-fs'); fs.__sw = true; }
    });
  }
  function decorateCards(root) {
    (root || document).querySelectorAll('.pcard-swatches span[title]').forEach(function (s) {
      var bg = bgFor(s.getAttribute('title'));
      if (bg) s.style.background = bg;
    });
  }
  /* shared with lunai-favorites.js: facet/sort AJAX swaps and the
     wishlist grid inject fresh card markup that needs the same paint */
  window.lunaiDecorateCards = decorateCards;
  /* ---- variant-level availability (Zadnji kos) --------------------------
     main-product renders [data-pd-avail] with a variantId→qty map; Dawn
     doesn't re-render that block on variant change, so re-evaluate here
     (called from init + the variant-selects MutationObserver). */
  function updateAvailability() {
    var el = document.querySelector('[data-pd-avail]');
    if (!el) return;
    var raw = el.getAttribute('data-qty-map');
    if (!raw) return;
    var qmap;
    try { qmap = JSON.parse(raw); } catch (e) { return; }
    var vs = document.querySelector('variant-selects [data-selected-variant]');
    var v = null;
    try { v = vs && JSON.parse(vs.textContent); } catch (e) {}
    var txt = el.querySelector('[data-pd-avail-text]');
    if (!txt) return;
    /* Chat 6: an option COMBINATION that has no variant (a product whose
       matrix has holes — `avtosedez-odisey` sells Siva in only one of its two
       size values) used to return here, which left the PREVIOUS variant's
       chip on screen. The shopper then read "Zadnji kos" beside a disabled
       "Ni na voljo" CTA — two contradictory answers to the same question.
       There is no stock fact to state about a variant that does not exist,
       so the chip stands down until a real variant is selected again.
       `hidden` alone loses to the author `display:flex` on .pd-availability,
       so the stylesheet carries an explicit [hidden] rule (same trap as
       P2-41). */
    if (!v || !v.id) {
      el.hidden = true;
      return;
    }
    el.hidden = false;
    var qty = qmap[String(v.id)];
    /* B7 audit fix: the chip must never show a green "Na zalogi" for a
       sold-out variant — qty <= 0 (or an untracked variant reporting
       available:false) flips it to the out state; untracked-but-
       available variants fall back to in-stock instead of keeping the
       previous variant's stale text. */
    var qtyKnown = typeof qty !== 'undefined';
    var soldOut = qtyKnown ? qty <= 0 : v.available === false;
    var last = qtyKnown && qty === 1;
    el.classList.toggle('pd-availability--out', soldOut);
    el.classList.toggle('pd-availability--last', !soldOut && last);
    txt.textContent = soldOut
      ? (LS['product.availability_sold_out'] || '')
      : last
        ? (LS['product.availability_last_item'] || '')
        : (LS['product.availability_in_stock'] || '');
  }
  /* ---- size-guide modal ------------------------------------------------
     Shows the product's own "Mere" measurements (written into the
     description as <strong>Mere</strong> + <ul> by the catalog import)
     plus a how-to-measure guide. Frosted card, Esc/scrim to close. */
  function productMereHTML() {
    /* R1.10: the description no longer renders as .product__description —
       it lives in the first accordion body. Catalog v3 descriptions are
       plain prose, so fall back to pulling measurement sentences. */
    var desc = document.querySelector('.product__description') ||
      document.querySelector('.pd-acc-band .pd-acc__body') ||
      document.querySelector('.pd-acc .pd-acc__body');
    if (!desc) return '';
    var strongs = desc.querySelectorAll('strong');
    for (var i = 0; i < strongs.length; i++) {
      if (/mere/i.test(strongs[i].textContent)) {
        var p = strongs[i].closest('p') || strongs[i];
        var ul = p.nextElementSibling;
        if (ul && ul.tagName === 'UL') {
          return '<h4>' + (LS['product.size_guide_measures_heading'] || '') + '</h4><ul class="lunai-sg__mere">' + ul.innerHTML + '</ul>';
        }
      }
    }
    function esc(t) {
      return t.replace(/[&<>"]/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
      });
    }
    var text = (desc.textContent || '').trim();
    var picks = [];
    text.split('. ').forEach(function (sen) {
      if (/((obseg|mere|dolžin|širin|višin|premer|velikost)[^.]*\d)|(\d+\s*[x×]\s*\d+\s*cm)/i.test(sen)) {
        picks.push(sen.trim().replace(/\.$/, ''));
      }
    });
    if (picks.length) {
      return '<h4>' + (LS['product.size_guide_measures_heading'] || '') + '</h4><ul class="lunai-sg__mere">' +
        picks.map(function (sen) { return '<li>' + esc(sen) + '.</li>'; }).join('') + '</ul>';
    }
    return '';
  }
  function openSizeGuide() {
    var existing = document.querySelector('.lunai-sg');
    if (existing) { existing.remove(); }
    var opener = document.activeElement;
    /* Prompt 5 (§27): the dialog is position:fixed, so without a scroll lock
       the page scrolled away underneath it — most visibly on a phone, where
       dragging anywhere on the scrim moved the PDP behind the card. Same
       mechanism Dawn's own modals use, and it remembers a lock that was
       already in place (quick-add sheet) instead of clearing it on close. */
    var lockWasHeld = document.body.classList.contains('overflow-hidden');
    var wrap = document.createElement('div');
    wrap.className = 'lunai-sg';
    wrap.innerHTML =
      '<div class="lunai-sg__scrim" data-sg-close></div>' +
      '<div class="lunai-sg__card" role="dialog" aria-modal="true" aria-label="' + (LS['product.size_guide_title'] || '') + '">' +
        '<button type="button" class="lunai-sg__x" data-sg-close aria-label="' + (LS['general.close'] || '') + '">&times;</button>' +
        '<h3>' + (LS['product.size_guide_title'] || '') + '</h3>' +
        productMereHTML() +
        '<h4>' + (LS['product.size_guide_how_heading'] || '') + '</h4>' +
        '<ul class="lunai-sg__how">' +
          '<li>' + (LS['product.size_guide_neck_html'] || '') + '</li>' +
          '<li>' + (LS['product.size_guide_chest_html'] || '') + '</li>' +
          '<li>' + (LS['product.size_guide_back_html'] || '') + '</li>' +
        '</ul>' +
        '<p class="lunai-sg__tip">' + (LS['product.size_guide_tip'] || '') + '</p>' +
      '</div>';
    document.body.appendChild(wrap);
    var onKey = function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var card = wrap.querySelector('.lunai-sg__card');
      if (!card) return;
      var f = card.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    function close() {
      wrap.classList.remove('is-open');
      document.removeEventListener('keydown', onKey);
      if (!lockWasHeld) document.body.classList.remove('overflow-hidden');
      setTimeout(function () { wrap.remove(); }, 240);
      if (opener && typeof opener.focus === 'function') opener.focus();
    }
    wrap.addEventListener('click', function (e) { if (e.target.closest('[data-sg-close]')) close(); });
    document.addEventListener('keydown', onKey);
    document.body.classList.add('overflow-hidden');
    requestAnimationFrame(function () { wrap.classList.add('is-open'); });
    var card = wrap.querySelector('.lunai-sg__card');
    if (card) {
      card.setAttribute('tabindex', '-1');
      card.focus();
    }
  }

  /* ---- size-guide trigger -----------------------------------------------
     Prompt 5: the trigger and the "Barva: value" / "Velikost: M" labels are
     rendered by Liquid now (`product-variant-picker`), so they are correct on
     first paint, survive Dawn's section re-render for free, and no longer
     depend on a letter-size heuristic. Which products get the guide is one
     rule in `lunai-fit-help` — worn-on-the-dog items only. Everything left
     here is the delegated open handler, shared by the size row and the
     locked-size spec chip. */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-sg-open]');
    if (!t) return;
    e.preventDefault();
    openSizeGuide();
  });

  /* ---- colour-aware gallery ------------------------------------------
     B7 (founder 2026-07-20); re-architected in Phase 4 (2026-08-09).

     Liquid (`lunai-media-colour`) decides which colour every medium
     belongs to and stamps it as `data-lunai-colour` on the stage item,
     the thumbnail and the lightbox item — so the initial HTML is already
     correct and this function only has to KEEP it correct while the
     shopper switches colour. No alt parsing, no second colour model.

     Rules (documented in 30-pdp-media-gallery-architecture.md):
       selected colour owns media   → show it + global (blank) media;
       nobody owns media            → colour is not a photographic axis,
                                      show everything;
       others own, selected doesn't → show global media only and tell the
                                      shopper the truth (never hand them
                                      another colour's photo silently).
     The stage never ends up empty: if the rules would empty it, the
     product's media stay visible and the note explains why. */
  var COLOUR_RE = /barv|colou?r/i;

  function selectedColourValue() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return null;
    var checked = vs.querySelector('input[type="radio"][data-option-name]:checked');
    if (checked && COLOUR_RE.test(checked.getAttribute('data-option-name') || '')) {
      return checked.value;
    }
    /* fallback: locate the colour control by its legend, then read it */
    var controls = vs.querySelectorAll('fieldset, .product-form__input--dropdown');
    for (var i = 0; i < controls.length; i++) {
      var ctl = controls[i];
      var first = ctl.querySelector('input[type="radio"], select, option');
      var oname = (first && first.getAttribute && first.getAttribute('data-option-name')) || '';
      var legend = ctl.querySelector('legend, .form__label, label');
      if (!COLOUR_RE.test(oname) && !(legend && COLOUR_RE.test(legend.textContent || ''))) continue;
      var sel = ctl.querySelector('input[type="radio"]:checked');
      if (sel) return sel.value;
      var dd = ctl.querySelector('select');
      if (dd) return dd.value;
    }
    return null;
  }

  function colourOf(el) {
    var v = el.getAttribute('data-lunai-colour');
    return v ? v.trim().toLowerCase() : '';
  }

  /* `settled` = the DOM reflects the new variant (Dawn's section fetch has
     landed). The immediate on-change pass runs unsettled so the picture
     reacts instantly, but it must not flash the "photos coming" note during
     the ~200 ms in which the new colour's featured media has not arrived. */
  function applyMediaColourFilter(settled) {
    var gallery = document.querySelector('.product__media-wrapper media-gallery');
    if (!gallery) return;
    var stage = Array.prototype.slice.call(gallery.querySelectorAll('.product__media-item'));
    if (!stage.length) return;
    /* No medium carries a colour = colour is not a photographic axis here
       (or the product has no colour option at all). Leave the DOM alone —
       in particular do not clear `lunai-media-off-variant`, which hides for
       a different reason and is Liquid's to set. */
    var stamped = stage.some(function (li) { return !!colourOf(li); });
    if (!stamped) return;

    var colour = selectedColourValue();
    var norm = colour ? colour.trim().toLowerCase() : '';

    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.thumbnail-list__item'));
    var modal = Array.prototype.slice.call(
      document.querySelectorAll('.product-media-modal__content [data-media-id]')
    );

    var ownsSelected = stage.concat(thumbs, modal).some(function (el) {
      return norm && colourOf(el) === norm;
    });
    var ownsAny = stage.concat(thumbs, modal).some(function (el) { return !!colourOf(el); });
    /* Is there any shared/global medium to fall back on? It decides which of
       the two colour-gap shapes we are in, and Liquid decides it the same way
       (`lunai_gap_shows_other` in main-product) so the server paint and this
       pass never disagree. The stage is the authority: it is the thing that
       must not end up empty. */
    var hasGlobal = stage.some(function (li) { return !colourOf(li); });

    function decide(el) {
      var c = colourOf(el);
      if (!c) return false;              // global media always stay
      if (ownsSelected) return c !== norm;
      /* Colour gap. With global media to show, the colour-specific ones stand
         down. With none, hiding them would empty the stage, so the whole set
         stays and the note tells the shopper they are looking at another
         colourway — see the note block below. */
      if (ownsAny) return hasGlobal;
      return false;
    }

    [stage, thumbs, modal].forEach(function (group) {
      group.forEach(function (el) { el.classList.toggle('lunai-media-hidden', decide(el)); });
    });

    /* Guard: the rules must never leave an empty stage. */
    var visible = stage.filter(function (li) { return !li.classList.contains('lunai-media-hidden'); });
    if (!visible.length) {
      [stage, thumbs, modal].forEach(function (group) {
        group.forEach(function (el) { el.classList.remove('lunai-media-hidden'); });
      });
      visible = stage;
    }

    /* Truthful note: photography exists for other colours but not this one —
       and it says WHICH of the two gaps it is, because "photos are coming"
       printed under a full gallery of another colourway is not true. */
    var note = gallery.querySelector('[data-lunai-colour-note]');
    if (note && settled !== false) {
      var gap = ownsAny && !ownsSelected && !!norm;
      if (gap) {
        var txt = note.getAttribute(hasGlobal ? 'data-note-pending' : 'data-note-other');
        if (txt && note.textContent.trim() !== txt) note.textContent = txt;
      }
      note.hidden = !gap;
    }

    syncGalleryToVisible(gallery, visible);
    syncOpenLightbox();
  }

  /* If the shopper opened the lightbox in the moment between tapping a colour
     and Dawn's section fetch landing, its counter was captured against a
     half-updated set ("1 / 4" for a five-photo colourway). Re-point it at the
     current set whenever the filter runs. */
  function syncOpenLightbox() {
    var modal = document.querySelector('product-modal');
    if (!modal || !modal.hasAttribute('open') || typeof modal.mediaList !== 'function') return;
    var list = modal.mediaList();
    if (!list.length) return;
    var active = modal.querySelector('[data-media-id].active');
    if (!active || list.indexOf(active) === -1) {
      modal.querySelectorAll('[data-media-id].active').forEach(function (el) {
        el.classList.remove('active');
      });
      list[0].classList.add('active');
    }
    if (typeof modal.updateCounter === 'function') modal.updateCounter();
    /* The info panel is rendered once by Liquid and only synced on open, so a
       variant landing under an open lightbox left the caption — and the price —
       on the previous one. */
    if (typeof modal.syncVariantLine === 'function') modal.syncVariantLine();
    if (typeof modal.syncPrice === 'function') modal.syncPrice();
  }

  /* Keep the counter, the active slide and the scroll offsets agreeing with
     the visible set. Dawn sizes the counter from the Liquid render and never
     recounts after we hide slides, and its scroll offsets are measured
     before the hide lands — which used to leave the shopper on the second
     photo of the colour they just picked. */
  function syncGalleryToVisible(gallery, visible) {
    var total = gallery.querySelector('.slider-counter--total');
    if (total) total.textContent = visible.length;

    /* The rail is rendered whenever ANY colourway needs it (Liquid's
       `lunai_multi_capable`), because Dawn never creates it after the first
       paint. Stand it down again for the colourways that show a single
       photo — one lone thumbnail under one picture is noise. */
    var railWrap = gallery.querySelector('.thumbnail-slider');
    if (railWrap) {
      var shown = 0;
      gallery.querySelectorAll('.thumbnail-list__item').forEach(function (li) {
        if (li.classList.contains('lunai-media-hidden')) return;
        // mirrors Dawn's `.thumbnail-list_item--variant:not(:first-child)`
        if (li.classList.contains('thumbnail-list_item--variant') && li.previousElementSibling) return;
        shown++;
      });
      railWrap.classList.toggle('lunai-rail-idle', shown < 2);
    }

    var active = gallery.querySelector('.product__media-item.is-active');
    if (!active || active.classList.contains('lunai-media-hidden')) {
      active = visible[0];
      if (active) {
        gallery.querySelectorAll('.product__media-item').forEach(function (li) {
          li.classList.remove('is-active');
        });
        active.classList.add('is-active');
      }
    }
    if (!active) return;

    var list = active.parentElement;
    if (list && list.scrollLeft !== active.offsetLeft) {
      list.scrollLeft = active.offsetLeft;
    }
    syncActiveIndicator(gallery, visible);
  }

  /* Marks the thumbnail that matches the active slide, keeps it inside the
     (vertically scrollable) desktop rail, and keeps the counter's current
     number honest. Dawn's own setActiveThumbnail only ever scrolls the rail
     HORIZONTALLY, which does nothing for the Lunai vertical rail. */
  function syncActiveIndicator(gallery, visible) {
    gallery = gallery || document.querySelector('.product__media-wrapper media-gallery');
    if (!gallery) return;
    var active = gallery.querySelector('.product__media-item.is-active');
    if (!active) return;

    if (!visible) {
      visible = Array.prototype.slice
        .call(gallery.querySelectorAll('.product__media-item'))
        .filter(function (li) { return !li.classList.contains('lunai-media-hidden'); });
    }
    var current = gallery.querySelector('.slider-counter--current');
    var idx = visible.indexOf(active);
    if (current && idx > -1) current.textContent = idx + 1;

    var target = active.getAttribute('data-media-id');
    var rail = gallery.querySelector('.thumbnail-list');
    if (!rail || !target) return;
    var activeThumb = null;
    rail.querySelectorAll('.thumbnail-list__item').forEach(function (li) {
      var btn = li.querySelector('button');
      if (!btn) return;
      if (li.getAttribute('data-target') === target) {
        activeThumb = li;
        btn.setAttribute('aria-current', 'true');
      } else {
        btn.removeAttribute('aria-current');
      }
    });
    if (!activeThumb) return;
    var top = activeThumb.offsetTop;
    var bottom = top + activeThumb.offsetHeight;
    if (top < rail.scrollTop) rail.scrollTop = top;
    else if (bottom > rail.scrollTop + rail.clientHeight) {
      rail.scrollTop = bottom - rail.clientHeight;
    }
  }


  /* ---- unavailable-combo auto-resolve: REMOVED (Prompt 5) -----------------
     It was written for products with one size per colour (a diagonal option
     matrix), to stop a pick stranding the shopper on a disabled CTA. It never
     ran. It stashed the last-touched option on the `variant-selects` element
     and read it back 550 ms later — but Dawn REPLACES that element on every
     variant change, so the stash was always gone by the time the resolver
     looked (proven live: `sameNode: false`, `lastOptName: null`).
     Shopify resolves the case natively anyway — on `posip-za-obrok-morska-
     deklica` (2 variants across a 2×2 grid) picking "45 g" moves Okus to
     "Zelena spirulina" on its own and the CTA stays enabled. Deleting the
     resolver also retires the `[data-lunai-variants]` payload it depended on:
     the full variant JSON, 23.5 KB of the 314 KB `mehka-oprsnica-textura`
     document, shipped on every PDP for nothing. */

  function init() {
    decoratePicker(document);
    decorateCards(document);
    updateAvailability();
    /* Liquid already shipped the right set — this only reconciles the
       counter/active slide, so it is safe (and cheap) to run at once. */
    applyMediaColourFilter(true);
    /* Picking a thumbnail or swiping the stage moves the active slide;
       Dawn updates its own state, we follow up with the vertical rail and
       the counter. */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.thumbnail-list__item button')) return;
      setTimeout(function () { syncActiveIndicator(); }, 60);
    });
    var viewer = document.querySelector('.product__media-wrapper [id^="GalleryViewer"]');
    if (viewer) {
      viewer.addEventListener('slideChanged', function () {
        setTimeout(function () { syncActiveIndicator(); }, 0);
      });
    }
    document.addEventListener('change', function () {
      /* immediate, so tapping a colour changes the picture on the same frame
         instead of 400 ms later (§17) */
      applyMediaColourFilter(false);
      setTimeout(updateAvailability, 350);
      setTimeout(function () { applyMediaColourFilter(true); }, 400);
    });
    // catch Dawn's post-load variant render
    setTimeout(function () { updateAvailability(); applyMediaColourFilter(true); }, 500);
    // re-decorate when Dawn re-renders the variant picker.
    // B7 audit fix: observe the stable info CONTAINER, not the
    // variant-selects node — Dawn's section re-render replaces
    // variant-selects itself, which detached the old observer and let
    // the swatch fallback vanish after the first variant change.
    var host = document.querySelector('.product__info-container') ||
               document.querySelector('variant-selects');
    if (host && 'MutationObserver' in window) {
      new MutationObserver(function () {
        decoratePicker(host);
        updateAvailability();
        applyMediaColourFilter(true);
      }).observe(host, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
